export async function useDirectusRedirect(slug: MaybeRefOrGetter<string>) {
  const route = toRef(slug)
  const { $directus, $readItems } = useNuxtApp()
  const localePath = useLocalePath()
  const { data: redirects } = await useAsyncData<{
    source_url: string
    target_url: string
  }[]>(`redirections`, async () => {
    return $directus.request<{ source_url: string, target_url: string }[]>($readItems('redirections', {
      limit: -1,
      sort: 'sort,source_url',
      fields: [
        'source_url',
        'target_url',
      ],
    }))
  })

  // console.log('Directus Redirects:', redirects.value?.length, 'redirects found')
  // console.table(redirects.value)

  function matchUrl(sourceUrl: string) {
    const regexPattern = `^${sourceUrl.replace(/\*/g, '.*').replace(/[+?^${}()|[\]\\]/g, '\\$&')}$`
    const regex = new RegExp(regexPattern)
    return regex.test(route.value)
  }

  const redirect = redirects.value?.find(redirect => matchUrl(redirect.source_url))
  // console.log('Directus Redirects:', route.value, 'matches', redirect?.source_url, '=>', redirect?.target_url)
  if (!redirect)
    return null

  const wildCardIndex = redirect.source_url.indexOf('*')
  if (wildCardIndex !== -1) {
    const matchedPart = route.value.substring(wildCardIndex)
    redirect.target_url = redirect.target_url.replace('*', matchedPart)
    // console.log('Directus Redirects: Transformed wildcard in target url to', redirect.target_url)
  }
  // console.log('Directus Redirects: Redirecting to', localePath(redirect.target_url))
  return localePath(redirect.target_url)
}
